function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 93.466,
    height: 37.54,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2806.63 1127.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1617.94,
    y1: 2293.64,
    x2: 1530.99,
    y2: 1592.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2806.63 378.27V748.9c0 208.23-125.99 378.36-280.12 378.36H280.14c-120.59 0-224.1-104.11-263.36-249.7C6.02 837.58.01 794.22.01 748.89V378.26C.01 170.1 125.99-.01 280.14-.01h2246.37c66.78 0 128.83 32.31 176.94 85.28 62.99 69.9 103.19 175.45 103.19 292.99z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2742.51 351.61v343.63c0 192.98-120.2 350.69-267.31 350.69H331.43c-115.08 0-213.87-96.48-251.31-231.42-10.29-37.11-16.04-77.31-16.04-119.27V351.61C64.08 158.63 184.34.92 331.42.92h2143.77c63.75 0 122.95 29.95 168.87 79.08 60.08 64.77 98.44 162.61 98.44 271.61z",
    style: {
      fill: "#8eca37",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1487.75 890.04C649.2 905.65 139.91 878.42 72.26 458.38c-5.74-33.04-8.48-68.74-8.18-106.77C64.08 158.63 184.34.92 331.42.92h2143.77c63.75 0 122.95 29.95 168.87 79.08 10.57 37.54 16.31 77.74 16.31 119.75 110.86 842.18-548.26 678.67-1172.62 690.3z",
    style: {
      fill: "#a9e02f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2432.01.92c-5.74 113.03-44.41 222.04-122.65 294.43-189.99 175.57-470.3 236.79-688.4 297.12-255.55 71.02-517.74 100.97-778.13 97.81-208.44-2.2-441.62-7.13-639.8-115.67-43.77-24.17-91.21-64.38-130.77-116.23-5.74-33.04-8.48-68.74-8.18-106.77C64.08 158.63 184.34.92 331.42.92h2100.59z",
    style: {
      fill: "#bff233",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.94 132.84-.02-.05c-47.54-70.35-132.21 26.94-158.11 66.59-47.66 72.95-63.89 188.47-57.52 298.03 1.33 22.28 45.98 60.5 64.76-38.54 40.31-213.29 132.88-206.2 157.89-266.13 7.63-18.27 5.01-42.12-7-59.9z",
    style: {
      fill: "#f7ffae",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.ef9ef6e6b8f6e3dc92d8dcab94f9e6fa.svg";
export { ForwardRef as ReactComponent };